import React, {useState, useEffect} from "react";
import CustomToolbar from "../../CustomToolbar";
import {Container, Dialog, Slide, TextField, Chip, CircularProgress} from "@material-ui/core";
import {MuiThemeProvider} from "@material-ui/core/styles";
import {Autocomplete} from "@material-ui/lab";

import FilterComponent from "components/CustomComponents/FilterComponent.js";
import {getCookie} from "components/auth/Helpers";
import MUIDataTable from "mui-datatables";
import {datatableTheme} from "assets/css/datatable-theme.js";
import SubTables from "./Components/SubTables.js";
import axios from "axios";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const AllocationRule = () => {
  const token = getCookie("token");
  const [isLoading, setIsLoading] = useState(true);
  const [openAddForm, setOpenAddForm] = useState(false); //for modal
  const [allocationRuleId, setAllocationRuleID] = useState(); //modal title
  const [formTitle, setFormTitle] = useState("Add"); //modal title
  const [filterDialog, setFilterDialog] = useState(false);
  const [items, setItems] = useState([]); //table items
  const [itemsBackup, setItemsBackup] = useState([]);
  const [suppliersList, setSuppliersList] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      await axios(`${process.env.REACT_APP_BASE_URL}/allocationRules`, {
        responseType: "json",
        headers: {Authorization: `Bearer ${token}`},
      }).then((response) => {
        setItems(response.data);
        setItemsBackup(response.data);
        return setIsLoading(false);
      });
    };
    fetchData();
  }, [openAddForm]);

  useEffect(() => {
    const fetchData = async () => {
      const suppliers = await axios(`${process.env.REACT_APP_BASE_URL}/suppliers`, {
        responseType: "json",
        headers: {Authorization: `Bearer ${token}`},
      }).then((response) => {
        setSuppliersList(response.data);
        return response.data;
      });
    };
    fetchData();
  }, []);

  const columns = [
    {
      name: "_id",
      options: {
        display: false,
      },
    },
    {
      name: "priority",
    },
    {
      name: "code",
      options: {
        filter: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div>
              <a
                onClick={() => {
                  handleAdd("Edit Allocation Rule - " + tableMeta.rowData[3], tableMeta.rowData[0]);
                }}
              >
                {value}
              </a>
            </div>
          );
        },
      },
    },
    {
      name: "name",
    },
    {
      name: "supplier_id",
      label: "Supplier",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return suppliersList.filter((e) => e._id === value)[0]
            ? suppliersList.filter((e) => e._id === value)[0]?.name
            : "";
        },
      },
    },
  ];

  const options = {
    filter: false,
    onRowsDelete: null,
    rowsPerPage: 20,
    rowsPerPageOptions: [20, 50, 100],
    selectToolbarPlacement: "replace",
    customToolbar: () => {
      return (
        <CustomToolbar
          listener={() => {
            handleAdd("Add New Allocation Rule");
          }}
          handleFilter={handleFilter}
        />
      );
    },
    onRowsDelete: (rowsDeleted, dataRows) => {
      const idsToDelete = rowsDeleted.data.map((d) => items[d.dataIndex]._id); // array of all ids to to be deleted
      axios
        .delete(`${process.env.REACT_APP_BASE_URL}/allocationRules/${idsToDelete}`, {
          responseType: "json",
          headers: {Authorization: `Bearer ${token}`},
        })
        .then((response) => {
          console.log("deleted");
        });
    },
    textLabels: {
      body: {
        noMatch: !isLoading && "Sorry, there is no matching data to display",
      },
    },
  };
  const handleFilter = () => {
    setFilterDialog(true);
  };

  const handleAdd = (title, allocationRuleId) => {
    setOpenAddForm(true);
    setAllocationRuleID(allocationRuleId);
    setFormTitle(title);
  };
  const handleCloseAddForm = () => setOpenAddForm(false);

  //Search component ---------------START--------------
  const handleChangeSearch = (e, newValue) => {
    if (newValue.length === 0) setItems(itemsBackup);
    else {
      let valueToSearch = [];
      newValue.forEach((newValueEntry) => {
        valueToSearch.push(
          ...itemsBackup.filter((e, i) => {
            if (!valueToSearch.map((eSearch) => eSearch._id).includes(e._id)) {
              if (e.name.toLowerCase().includes(newValueEntry.toLowerCase())) {
                return true;
              }
            }
          })
        );
      });
      setItems(valueToSearch);
    }
  };
  //Search component ---------------END--------------
  return (
    <Container maxWidth="xl">
      <Autocomplete
        multiple
        freeSolo
        limitTags={3}
        id="tags-standard"
        options={[]}
        getOptionLabel={(option) => option}
        onChange={handleChangeSearch}
        renderInput={(params) => (
          <TextField {...params} variant="standard" placeholder="Search Data" label="Filter by Name" />
        )}
      />

      {!isLoading ? (
        <MuiThemeProvider theme={datatableTheme}>
          <MUIDataTable title="" data={items} columns={columns} options={options} />
        </MuiThemeProvider>
      ) : (
        <CircularProgress size={30} className="pageLoader" />
      )}

      <div>
        <Dialog fullScreen open={openAddForm} onClose={handleCloseAddForm} TransitionComponent={Transition}>
          <SubTables title={formTitle} handleClose={handleCloseAddForm} allocationRuleId={allocationRuleId} />
        </Dialog>
        {/*********************** FILTER start ****************************/}
        <Dialog
          onClose={() => setFilterDialog(false)}
          maxWidth={"xl"}
          fullWidth
          aria-labelledby="customized-dialog-title"
          open={filterDialog}
        >
          <FilterComponent setOpenDialog={setFilterDialog} />
        </Dialog>
      </div>
    </Container>
  );
};
export default AllocationRule;
